var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#question_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#question_svg__b)",
  d: "M21.456 40a3.96 3.96 0 0 1-2.093-.597l-.71-.437a2.27 2.27 0 0 0-1.873-.244l-.794.244a3.96 3.96 0 0 1-4.465-1.557l-.473-.69a2.28 2.28 0 0 0-1.62-.984l-.827-.092a3.98 3.98 0 0 1-3.452-3.205l-.144-.858a2.27 2.27 0 0 0-1.08-1.548l-.735-.42a3.93 3.93 0 0 1-1.823-4.35l.194-.824a2.25 2.25 0 0 0-.346-1.85l-.48-.682a3.93 3.93 0 0 1 .109-4.711l.515-.656a2.3 2.3 0 0 0 .439-1.843l-.17-.84a3.95 3.95 0 0 1 2.027-4.274l.734-.396A2.26 2.26 0 0 0 5.545 7.69l.177-.824a3.944 3.944 0 0 1 3.596-3.08l.836-.066a2.26 2.26 0 0 0 1.671-.9l.507-.665A3.96 3.96 0 0 1 16.847.799l.785.278a2.3 2.3 0 0 0 1.9-.151l.725-.404a3.97 3.97 0 0 1 4.693.597l.591.564a2.25 2.25 0 0 0 1.781.614l.852-.076a3.955 3.955 0 0 1 4.044 2.448l.312.782a2.31 2.31 0 0 0 1.384 1.296l.785.27a3.92 3.92 0 0 1 2.693 3.869v.816c-.026.69.236 1.32.725 1.775l.617.563a3.97 3.97 0 0 1 .886 4.635l-.363.75a2.2 2.2 0 0 0-.042 1.883l.329.774a3.92 3.92 0 0 1-1.08 4.577l-.65.513a2.26 2.26 0 0 0-.82 1.707v.833a3.97 3.97 0 0 1-2.894 3.845l-.794.235a2.28 2.28 0 0 0-1.443 1.228l-.346.749a3.97 3.97 0 0 1-4.153 2.271l-.844-.117a2.3 2.3 0 0 0-1.815.546l-.624.547a4.03 4.03 0 0 1-2.625.984m-4.01-3.062c.735 0 1.46.202 2.094.598l.709.437c.86.53 1.95.446 2.718-.219l.624-.546a4 4 0 0 1 3.157-.951l.852.118a2.3 2.3 0 0 0 2.398-1.304l.346-.749a3.95 3.95 0 0 1 2.498-2.137l.802-.235h.008a2.28 2.28 0 0 0 1.672-2.221v-.85a3.95 3.95 0 0 1 1.418-2.986l.633-.53a2.25 2.25 0 0 0 .616-2.633l-.32-.774a3.86 3.86 0 0 1 .084-3.272l.362-.74a2.29 2.29 0 0 0-.506-2.667l-.608-.555a3.92 3.92 0 0 1-1.266-3.037v-.808a2.26 2.26 0 0 0-1.553-2.246l-.793-.269a4 4 0 0 1-2.397-2.246l-.313-.782a2.28 2.28 0 0 0-2.32-1.405l-.845.076a3.93 3.93 0 0 1-3.106-1.069l-.6-.572a2.28 2.28 0 0 0-2.7-.345l-.768.362a4 4 0 0 1-3.292.27l-.777-.278a2.26 2.26 0 0 0-2.6.773l-.514.673a3.94 3.94 0 0 1-2.895 1.565l-.836.067A2.27 2.27 0 0 0 7.36 7.218l-.177.824a3.95 3.95 0 0 1-2.01 2.625l-.725.395a2.27 2.27 0 0 0-1.165 2.465l.169.841a3.97 3.97 0 0 1-.76 3.205l-.515.657a2.27 2.27 0 0 0-.059 2.708l.481.682c.659.933.878 2.103.608 3.205l-.194.832a2.27 2.27 0 0 0 1.047 2.516l.717.429a3.96 3.96 0 0 1 1.874 2.7l.143.85a2.28 2.28 0 0 0 1.984 1.825l.836.093a4.02 4.02 0 0 1 2.819 1.707l.472.69a2.3 2.3 0 0 0 2.575.9l.793-.244a3.8 3.8 0 0 1 1.174-.185"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#question_svg__c)",
  d: "M9.707 10.995a.82.82 0 0 1-.583-.236.83.83 0 0 1-.025-1.186 15.2 15.2 0 0 1 3.494-2.725.835.835 0 0 1 1.148.31.837.837 0 0 1-.312 1.145 13.8 13.8 0 0 0-3.106 2.422.85.85 0 0 1-.616.27"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#question_svg__d)",
  d: "M5.967 18.339c-.05 0-.093 0-.143-.009a.845.845 0 0 1-.692-.967 14.6 14.6 0 0 1 1.308-4.004.835.835 0 0 1 1.13-.379.83.83 0 0 1 .38 1.127 12.8 12.8 0 0 0-1.156 3.55c-.059.387-.422.682-.827.682"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#question_svg__e)",
  d: "M6.972 26.65a.84.84 0 0 1-.769-.496 15.3 15.3 0 0 1-.996-3.088.843.843 0 0 1 1.655-.336c.194.942.49 1.867.878 2.742a.84.84 0 0 1-.43 1.11.9.9 0 0 1-.338.068"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#question_svg__f)",
  d: "M11.715 32.471a.8.8 0 0 1-.49-.16 15 15 0 0 1-3.072-2.944.84.84 0 0 1 .143-1.178.845.845 0 0 1 1.182.143 13 13 0 0 0 2.735 2.608.844.844 0 0 1-.498 1.531"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#question_svg__g)",
  d: "M20.046 35.163c-1.814 0-3.595-.32-5.3-.95a.843.843 0 1 1 .59-1.582c1.528.572 3.149.841 4.77.85a.84.84 0 1 1 0 1.682z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#question_svg__h)",
  d: "M25.11 34.246a.85.85 0 0 1-.793-.547.847.847 0 0 1 .498-1.085 13.5 13.5 0 0 0 3.976-2.305.846.846 0 0 1 1.19.101.847.847 0 0 1-.102 1.186 15.3 15.3 0 0 1-4.465 2.591.8.8 0 0 1-.304.06"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#question_svg__i)",
  d: "M32.538 27.996a.85.85 0 0 1-.422-.11.85.85 0 0 1-.312-1.152 13.5 13.5 0 0 0 1.477-3.81.853.853 0 0 1 1.004-.648.85.85 0 0 1 .65 1 15 15 0 0 1-1.663 4.3.84.84 0 0 1-.734.42"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#question_svg__j)",
  d: "M20.485 28.316c-.802 0-1.46-.253-1.958-.758-.49-.496-.734-1.135-.734-1.9 0-.75.253-1.38.742-1.877q.494-.491 1.19-.656a1.6 1.6 0 0 1-.523-.404q-.456-.53-.456-1.362c0-.74.144-1.447.423-2.087.27-.63.734-1.295 1.375-1.985.372-.404.633-.74.768-.993.119-.218.17-.445.17-.673 0-.244-.085-.344-.186-.42-.17-.135-.473-.202-.87-.202q-.71 0-1.291.177a5.8 5.8 0 0 0-1.182.513c-.717.37-1.342.446-1.882.244a1.93 1.93 0 0 1-1.157-1.11c-.21-.514-.219-1.06-.008-1.633.203-.555.625-1.018 1.266-1.37a9.2 9.2 0 0 1 2.22-.867c2-.505 3.798-.362 5.191.235.87.37 1.562.909 2.051 1.598.506.699.76 1.523.76 2.44 0 .808-.186 1.565-.549 2.255-.354.68-.954 1.354-1.815 2.069-.802.665-1.14 1.085-1.291 1.32a2.9 2.9 0 0 0-.397 1.052c-.076.42-.278.774-.582 1.018a1.6 1.6 0 0 1-.397.236c.414.117.777.336 1.064.639q.709.745.709 1.867c0 .758-.237 1.397-.71 1.893-.48.48-1.13.74-1.94.74m0-3.828c-.405 0-.709.1-.92.32-.22.218-.312.488-.312.85 0 .378.101.664.32.883.212.218.516.32.912.32.397 0 .684-.102.878-.312.211-.219.312-.513.312-.9 0-.37-.1-.64-.303-.858-.203-.202-.49-.303-.887-.303m-.067-10.944c.734 0 1.333.176 1.772.513.49.378.743.917.743 1.564 0 .455-.11.909-.33 1.33-.193.386-.522.816-.995 1.32-.532.564-.903 1.094-1.106 1.573a3.7 3.7 0 0 0-.304 1.515c0 .134.017.31.102.412.025.025.067.075.227.075.22 0 .287-.042.287-.042a.25.25 0 0 0 .076-.151 4.3 4.3 0 0 1 .591-1.565c.304-.488.827-1.034 1.596-1.674.709-.58 1.198-1.127 1.46-1.623.253-.48.38-1.001.38-1.573 0-.614-.16-1.136-.482-1.59-.337-.463-.818-.841-1.443-1.102-1.097-.471-2.574-.59-4.262-.168a7.3 7.3 0 0 0-1.866.731c-.32.177-.532.387-.607.606-.102.286-.06.463-.009.572.068.16.152.244.312.303.144.05.38 0 .676-.152.447-.26.953-.487 1.468-.639a6 6 0 0 1 1.714-.235"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "question_svg__b",
  x1: 20.006,
  x2: 20.006,
  y1: 0.013,
  y2: 40,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F56B57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3863F0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "question_svg__c",
  x1: 11.357,
  x2: 11.357,
  y1: 6.734,
  y2: 10.995,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F56B57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3863F0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "question_svg__d",
  x1: 6.581,
  x2: 6.581,
  y1: 12.889,
  y2: 18.339,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F56B57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3863F0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "question_svg__e",
  x1: 6.501,
  x2: 6.501,
  y1: 22.057,
  y2: 26.65,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F56B57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3863F0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "question_svg__f",
  x1: 10.27,
  x2: 10.27,
  y1: 28.012,
  y2: 32.471,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F56B57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3863F0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "question_svg__g",
  x1: 17.572,
  x2: 17.572,
  y1: 32.579,
  y2: 35.163,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F56B57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3863F0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "question_svg__h",
  x1: 27.221,
  x2: 27.221,
  y1: 30.11,
  y2: 34.246,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F56B57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3863F0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "question_svg__i",
  x1: 33.323,
  x2: 33.323,
  y1: 22.258,
  y2: 27.996,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F56B57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3863F0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "question_svg__j",
  x1: 20.573,
  x2: 20.573,
  y1: 10.645,
  y2: 28.316,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F56B57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3863F0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "question_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})))));
export default SvgQuestion;